import React from 'react'
import {
  Grid,
  Typography,
  useMediaQuery,
  Card,
  CardContent,
} from '@mui/material'
import { Formik, Field, Form } from 'formik'
import { useDispatch } from 'react-redux'
import MyButton from '../../ui/MyButton'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { TextField } from 'formik-material-ui'
import LessonPeriodForm from './LessonPeriodForm'
import * as yup from 'yup'
import { makeStyles, useTheme } from '@mui/styles'
import { createALesson } from '../../../actions/typeOfLesson'
import { Save } from '@mui/icons-material'

const useStyles = makeStyles((theme) => ({
  bottomGutterFormControl: {
    marginBottom: '1.5em',
  },
  controlFormHeader: {
    fontWeight: '500',
    fontSize: '18px',
  },
}))

const AddALesson = (props) => {
  const classes = useStyles()

  const theme = useTheme()
  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'))
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))

  const dispatch = useDispatch()

  const initialValues = {
    lessonName: '',
    content: '',
    documents: [],
    periods: [
      {
        thirtyMinutes: { isChosen: false, price: 0 },
        fortyFiveMinutes: { isChosen: false, price: 0 },
        oneHour: { isChosen: false, price: 0 },
      },
    ],
  }

  const validationSchema = yup.object().shape({
    lessonName: yup.string().required('Type of lesson is required'),
    content: yup.string().required('Lesson\'s content is required'),
    documents: yup.array(),
    periods: yup.array(),
  })

  const handleSubmit = async (values, { resetForm }) => {
    dispatch(createALesson(values))

    props.history.push('/teachers/lessons')

    resetForm({
      lessonName: '',
      content: '',
      documents: [],
      periods: [
        { thirtyMinutes: { isChosen: false, price: 0 } },
        { fortyFiveMinutes: { isChosen: false, price: 0 } },
        { oneHour: { isChosen: false, price: 0 } },
      ],
    })
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
    >
      {({ isValid, values, dirty }) => (
        <Form>
          <Grid
            container
            direction="column"
            alignItems="center"
            className="container"
            spacing={2}
          >
            <Grid item>
              <Typography
                variant={matchesMD ? 'h4' : 'h5'}
                style={{
                  textTransform: 'uppercase',
                  fontWeight: '600',
                  alignText: 'center',
                }}
              >
                Add a type of lesson
              </Typography>
            </Grid>

            <Grid item>
              <Card>
                <CardContent>
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                  >
                    <Grid
                      item
                      style={{
                        width: matchesMD ? '60%' : matchesSM ? '80%' : '100%',
                      }}
                    >
                      <Field
                        fullWidth
                        name="lessonName"
                        component={TextField}
                        label="Type of lesson (e.g., conversation English)"
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        width: matchesMD ? '60%' : matchesSM ? '80%' : '100%',
                      }}
                    >
                      <Field
                        fullWidth
                        name="content"
                        component={TextField}
                        multiline
                        rows={4}
                        label="Lesson's content"
                      />
                    </Grid>

                    {/* <AddDocuments /> */}

                    <Grid item>
                      <Typography
                        variant="h6"
                        className={classes.controlFormHeader}
                      >
                        Lesson's duration:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      direction={matchesMD ? 'row' : 'column'}
                      container
                      justifyContent="center"
                      alignItems="center"
                      spacing={1}
                    >
                      <Grid item>
                        <LessonPeriodForm
                          fieldCheckbox="periods[0].thirtyMinutes.isChosen"
                          labelCheckbox="30 minutes"
                          valueCheckbox={
                            values.periods[0].thirtyMinutes.isChosen
                          }
                          fieldPrice="periods[0].thirtyMinutes.price"
                          valuePrice={values.periods[0].thirtyMinutes.price}
                        />
                      </Grid>

                      <Grid item>
                        <LessonPeriodForm
                          fieldCheckbox="periods[0].fortyFiveMinutes.isChosen"
                          labelCheckbox="45 minutes"
                          valueCheckbox={
                            values.periods[0].fortyFiveMinutes.isChosen
                          }
                          fieldPrice="periods[0].fortyFiveMinutes.price"
                          valuePrice={values.periods[0].fortyFiveMinutes.price}
                        />
                      </Grid>

                      <Grid item>
                        <LessonPeriodForm
                          fieldCheckbox="periods[0].oneHour.isChosen"
                          labelCheckbox="1 hour"
                          valueCheckbox={values.periods[0].oneHour.isChosen}
                          fieldPrice="periods[0].oneHour.price"
                          valuePrice={values.periods[0].oneHour.price}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid
              item
              container
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item>
                <MyButton component={Link} to="/teachers/lessons">
                  <ArrowBackIcon />
                  &nbsp;Back
                </MyButton>
              </Grid>
              <Grid item>
                <MyButton type="submit" disabled={!(isValid && dirty)}>
                  <Save />
                  &nbsp;Save
                </MyButton>
              </Grid>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
}

export default AddALesson
